import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <GetInTouch />
      <Footer />
    </div>;
}